import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { TipoUniversoService } from 'src/app/services/tipo-universo.service';
import { IRiscosChavesModel, IRiscosChavesProcessoItemModel } from "src/app/models/riscos-chaves.model";
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ITipoUniversoModel,
  ITipoUniversoItemModel,
  ITipoUniversoUGModel
} from 'src/app/models/tipo-universo.model';
import Swal from "sweetalert2";
import { SharedService } from "../../../../services/shared.service";
import { IRiscosChavesProcesso } from 'src/app/models/riscos-chaves-processo ';
import { ERiscosChavesSituacao, ERiscosChavesSituacaoDescricao } from 'src/app/models/enum/riscos-chaves-situacao';
import { ModalDelegarComponent } from 'src/app/pages/pre-planejamento-resposta-form/modal-delegar/modal-delegar.component';
import { ResponsaveisService } from 'src/app/services/responsaveis.service';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { ModalDelegarRiscoChaveComponent } from './modal-delegar-risco-chave/modal-delegar-risco-chave.component';

@Component({
  selector: 'app-riscos-chaves-preenchimento-form',
  templateUrl: './riscos-chaves-preenchimento-form.component.html',
  styleUrls: ['./riscos-chaves-preenchimento-form.component.scss']
})
export class RiscosChavesPreenchimentoFormComponent extends BaseFormComponent implements OnInit {

  public tipoUniversoId: number;
  public unidadeGestoraId: number;
  public criterioAvaliacaoId: number;
  public criterioId: string;
  public unidadeGestora: number;
  public processoId: number;
  public semDados: boolean;
  public modelRiscosChaves: IRiscosChavesModel = {} as IRiscosChavesModel;
  public modelTipoUniverso: ITipoUniversoModel = {} as ITipoUniversoModel;
  public modelTipoUniversoItens: ITipoUniversoUGModel = {} as ITipoUniversoUGModel;
  public modelRiscosChavesProcessoItemModel: IRiscosChavesProcessoItemModel[] = []; public idClassificacaoTipo: number;
  habilitaBotaoFinalizar: boolean = false;
  titulo: string = '';
  nomeRiscoChaves: string = ' ';

  listRiscosProcessos: any[] = []
  selectedIds: number[] = [];
  selectedItems: any[] = [];

  selectedRiscos: any[] = [];
  todosSelecionados = false;

  imprimir: boolean;

  situacao!: string;

  selection = new SelectionModel<any>(true, []);

  constructor(route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private sharedService: SharedService,
    private riscosChavesService: RiscosChavesServices,
    private tipoUniversoService: TipoUniversoService,
    private responsaveisService: ResponsaveisService,
    private criterioAvaliacaoService: CriteriosAvaliacaoRiscoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);

  }

  model: any;

  async ngOnInit() {
    this.situacao = this.route.snapshot.paramMap.get("status");
    debugger
    this.route.data.subscribe(data => {
      if (data?.acao == 'Imprimir') { this.imprimir = true; }
      else { this.imprimir = false; }

      if (data?.acao === 'Visualizar') {
        // this.habilitaBotaoFinalizar = true;
        this.titulo = 'Visualizar';
      } else {
        this.titulo = 'Responder';
      }

    });

    if (this.id) {
      const res = await this.riscosChavesService.obterPorId(this.id);
      if (res.sucesso) {
        this.model = res.dados;
        this.tipoUniversoId = res.dados.tipoUniversoAuditavelId;
        this.unidadeGestoraId = res.dados.unidadeGestoraId;
        this.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;
        this.nomeRiscoChaves = res.dados?.nomeTipoUniverso;
      }

      const retProc = await this.riscosChavesService.obterProcesso(this.id)
      if (retProc.sucesso) {
        this.listRiscosProcessos = retProc.dados
      }
    }
    if (this.tipoUniversoId != null) {
      this.buscarTipoUniverso(this.tipoUniversoId);
    }
  }

  public async buscarTipoUniverso(idTipo: number) {
    const res = await this.tipoUniversoService.obterPorId(idTipo);
    if (res.sucesso) {
      this.idClassificacaoTipo = res.dados.tipo;
    }

    this.buscarItens(this.tipoUniversoId, this.unidadeGestoraId);
  }

  retornoAbaRisco() {
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  public async buscarItens(idTipoUniverso: number, idUG: number) {
    const paramsUG = this.idClassificacaoTipo == 2 ? idUG : null;

    if (idTipoUniverso) {
      const res = await this.tipoUniversoService.obterItens(idTipoUniverso, paramsUG);
      if (res.sucesso) {
        this.modelTipoUniversoItens = res.dados;
        this.criterioId = this.criterioAvaliacaoId.toString();
      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }

      this.obterDescricaoRisco();
      this.reordenar();
    }
  }

  public async abrirPreenchimento(processoId: number, modoVisualizar: boolean = false, subtipo: string = '', macroprocesso: string = '', processo: string = '') {
    const res = await this.criterioAvaliacaoService.obterPorId(this.criterioAvaliacaoId);
    if (res.sucesso) {
      if (this.id) {
        localStorage.setItem('modoVisualizar', modoVisualizar.toString());
        this.router.navigate(
          [`/preenchimento-riscos-criterios-preencher`, this.id, processoId, this.unidadeGestoraId],
        );
        this.sharedService.setParamsRiscos(subtipo, macroprocesso, processo);
      }
    }
  }

  getRiscosPorProcesso(processoId: number) {
    const riscos = this.modelRiscosChavesProcessoItemModel.filter(risco => risco.processoId === processoId);
    return riscos.length > 0 ? riscos : [{ nomeRisco: '', ri: 0, rr: 0 }];
  }

  public obterDescricaoRisco() {
    this.riscosChavesService.obterItensProcesso(this.id, null).then(res => {
      if (res.sucesso) {
        this.modelRiscosChavesProcessoItemModel = Array.isArray(res.dados) ? res.dados : [res.dados];
      }
    })
  }

  getMagnitude(processos: any[]): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    processos.forEach(processo => {
      const riscos = this.modelRiscosChavesProcessoItemModel.filter(r => r.processoId === processo.id);

      riscos.forEach(risco => {
        riTotal += risco.ri || 0;
        rrTotal += risco.rr || 0;
      });
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }

  getMagnitudeMacro(macros: any[]): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    macros.forEach(macro => {
      const magnitudeMacro = this.getMagnitude(macro.itens);
      riTotal += magnitudeMacro.riTotal;
      rrTotal += magnitudeMacro.rrTotal;
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }

  getMagnitudeTotal(): { riTotal: number, rrTotal: number } {
    let riTotal = 0;
    let rrTotal = 0;

    if (!this.modelTipoUniversoItens?.itens || this.modelTipoUniversoItens.itens.length === 0) {
      return { riTotal: 0, rrTotal: 0 };
    }

    this.modelTipoUniversoItens.itens.forEach(subtipo => {
      const magnitudeSubtipo = this.getMagnitudeMacro(subtipo.itens ?? []);
      riTotal += magnitudeSubtipo.riTotal;
      rrTotal += magnitudeSubtipo.rrTotal;
    });

    return {
      riTotal: parseFloat(riTotal.toFixed(2)),
      rrTotal: parseFloat(rrTotal.toFixed(2))
    };
  }

  getRowSpan(subtipo: any): number {
    let rowCount = 0;
    subtipo.itens.forEach(macro => {
      if (macro.tipo === 2) {
        rowCount += macro.itens.length || 1; // Se não houver processos, contar pelo menos 1 linha
      }
    });
    return rowCount || 1; // Se não houver macros, contar pelo menos 1 linha
  }

  public onBack() {
    this.submit = false;
    this.router.navigateByUrl(`/unidades-gestoras/${this.unidadeGestoraId}?aba=4`);
  }

  onFinalizar() {

    let idsSelecionados: number[] = [];
    if (this.selectedIds.length > 0) {
      idsSelecionados = this.selectedIds;
    } else {
      // @ts-ignore
      idsSelecionados = this.selection.selected.map(item => {
        if (item.idTipoSecaoOuPergunta != 1) {
          return item.idItemQuestionario;
        }
        return null;
      }).filter(id => id !== null);
    }
    const idsSelecionadosString: string = idsSelecionados.join(',');

    this.riscosChavesService.FinalizarQuestionario(idsSelecionadosString, this.id)
      .then((res) => {
        if (res.sucesso) {
          this.exibirMensagemSucesso("Registro finalizado com sucesso!");
          window.location.reload();
        }
        else {
          this.exibirMensagemErro(res.mensagem.descricao);
        }
      })

  }

  public reordenar() {
    this.modelTipoUniversoItens.itens.forEach((item, idx) => {
      item.ordem = (idx + 1);
      item.ordemExibicao = `1.${item.ordem.toString()}`;
      if (item.itens && item.itens.length > 0) {
        this.fnReordenacao(item);
      }
    });
  }

  public fnReordenacao(item: ITipoUniversoItemModel) {
    item.itens.forEach((subItem, subIdx) => {

      subItem.ordem = subIdx + 1;
      subItem.ordemExibicao = `${item.ordemExibicao}.${subItem.ordem.toString()}`
      if (subItem.itens && subItem.itens.length > 0) {
        this.fnReordenacao(subItem);
      }
    });
  }

  getStatus(processo: number) {
    const status = this.listRiscosProcessos.find(o => o.processoId == processo)?.statusId
    return this.getDescricaoSituacao(status)
  }

  canEnviar() {
    return this.listRiscosProcessos.every(x => x.statusId === 5);
  }

  getRepresentante(processo: number) {
    return this.listRiscosProcessos.find(o => o.processoId == processo)?.nomeDelegadoA
  }

  getDescricaoSituacao(valor: number): string {
    return ERiscosChavesSituacaoDescricao[valor as ERiscosChavesSituacao] ?? '';
  }

  async modalDelegar() {
    const idsParaDelegar: string = this.selectedIds.join(',');

    const res = await this.responsaveisService.obter(
      this.unidadeGestoraId, '', '', '', true
    );

    if (res.sucesso) {
      try {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = 'modal-component';
        dialogConfig.width = '500px';
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          questionarioId: idsParaDelegar,
          dados: res.dados,
          riscoChaveId: this.id
        };

        const modal = this.matDialog.open(
          ModalDelegarRiscoChaveComponent,
          dialogConfig
        );

        modal.afterClosed().subscribe(async (result) => {
          if (result === true) {
            this.submit = true;
            window.location.reload();
            this.exibirMensagemSucesso("Registro delegado com sucesso");
          }
        });
      } catch (err) {
        this.exibirMensagemErro(err.mensagem.descricao);
      }
    }
  }

  onCheckboxChange(event: MatCheckboxChange, element: any) {
    if (event.checked) {
      if (!this.checkExists(element.id)) {
        this.selectedIds.push(element.id);
        this.selection.toggle(element);
      }
    } else {
      const index = this.selectedIds.indexOf(element.id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
        this.selection.deselect(element);
      }
    }
    this.habilitaBotaoFinalizar = this.selectedIds.length > 0;
  }

  checkExists(value): boolean {
    return this.selectedIds.includes(value);
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.habilitaBotaoFinalizar = false;
    } else {
      // this.dataSource2.forEach(row => this.selection.select(row));
      this.habilitaBotaoFinalizar = true;
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    // const numRows = this.dataSource2.filter(x => x.idTipoSecaoOuPergunta != 1).length;
    return numSelected === numSelected;
  }

  async onSalvar(salvarEFechar: boolean) {
    this.riscosChavesService.SalvarQuestionario(this.id).then((res) => {
      if (res.sucesso) {
        if (salvarEFechar == true) {
          this.router.navigate([`/questionario/pre-planejamento`]);
        }
        else {
          this.exibirMensagemSucesso('Registro Salvo com Sucesso!')
          window.location.reload();
        }
      }
      else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    })
  }

  onEnviar() {
    Swal.fire({
      title: 'Enviar Resposta',
      text: "Deseja enviar a Resposta selecionada? Esta ação não poderá ser desfeita ",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((res) => {
      if (res.value) {
        this.riscosChavesService.EnviarQuestionario(this.id)
          .then((res) => {
            if (res.sucesso) {
              this.router.navigate([`/questionario/pre-planejamento`]);
            }
            else {
              this.exibirMensagemErro(res.mensagem.descricao);
            }
          })
      }
    })
  }

  onCancelar() {
    if (this.visualizar || this.imprimir) {
      this.router.navigate([`/questionario/pre-planejamento`]);
    } else {
      Swal.fire({
        title: 'Atenção',
        text: "Todas as informações preenchidas serão perdidas. Deseja continuar? ",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((res) => {
        if (res.value) {
          this.router.navigate([`/questionario/pre-planejamento`]);
        }
      })
    }
  }

  isSelecionado(item): boolean {
    return this.selectedIds.includes(item.id);
  }

  checkIt(item: any, event: any) {
    debugger
    if (this.selectedIds.includes(item.id)) {
      const index = this.selectedIds.indexOf(item.id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      }
    } else {
      this.selectedIds.push(item.id)
    }
    this.habilitaBotaoFinalizar = this.selectedIds.length > 0;
  }

  getStatusClass(status: any): string {
    if (!this.imprimir) return ''
    return (status === 'Finalizado' || status === 'Enviado') ? '' : 'minuta';
  }

  isSelected(id: any): boolean {
    return this.selectedIds.includes(id)
  }

}
